export { default } from './PageHistoricalFigure.vue'
